import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { H3 } from '~typography';
var Title = styled(H3).withConfig({
  displayName: "Title",
  componentId: "sc-1pln5gt-0"
})(["padding:0 ", ";text-align:", ";transform:translateY(-", ");", ""], rem(20), function (_ref) {
  var isVertical = _ref.isVertical;
  return isVertical ? 'center' : 'left';
}, rem(2), function (_ref2) {
  var hasLogo = _ref2.hasLogo;
  return !hasLogo && css(["padding:0;"]);
});
export default Title;